import React, { Fragment, useState } from "react";
import moment from "moment";
import "moment-timezone";
import { Dropdown } from "react-bootstrap";
import CriticalIcon from "../../assests/img/critical-icon.svg";
import CriticalLevelIcon from "../../assests/img/critical-level-icon.svg";
import InProgressIcon from "../../assests/img/inProgress-icon.svg";

import E1Icon from "../../assests/img/E1-icon.svg";
import E2Icon from "../../assests/img/E2-icon.svg";
import E3Icon from "../../assests/img/E3-icon.svg";
import OverdueIcon from "../../assests/img/overdue-icon.svg";
import ReOpenIcon from "../../assests/img/menu/reopen.png";
import starIcon from "../../assests/img/Ratings/star-icon.svg";
import ReturnedTicketRedIcon from "../../assests/img/menu/ReturnedTicketRed.svg";
import "./Tickets.css";
import NewCommentIcon from "../../assests/img/menu/newComment.png"

const Ticket = ({
  ticket,
  handleButtonClick,
  handleSelectButtonClick,
  selectedTicketId,
  ticketDetailsId,
  openNewTabWithRoute,
}) => {
  const dueDate = moment(ticket?.dueDate).tz("Asia/Kolkata");
  const now = moment().tz("Asia/Kolkata");

  let dueText;
  if (dueDate.isSame(now, "day")) {
    dueText = `Due by ${dueDate.format("hh:mm A")}`;
  } else if (dueDate.isSame(now.clone().subtract(1, "day"), "day")) {
    dueText = "Due by yesterday";
  } else if (dueDate.isSame(now.clone().add(1, "day"), "day")) {
    dueText = "Due by tomorrow";
  } else if (dueDate.isAfter(now, "day")) {
    dueText = `Due by ${dueDate.format("DD MMM")}`;
  } else {
    dueText = `Due by ${dueDate.format("DD MMM")}`;
  }

  let groupTypeValue = "";
  if (ticket !== null && ticket !== undefined) {
    for (const e of ticket.assignee) {
      if (e.stage === ticket.currentStage) {
        groupTypeValue = e.groupType;
        break;
      }
    }
  }
 
  let buttonValues = [];
  if (ticket !== null && ticket !== undefined) {
    buttonValues = ticket?.statusOption?.map((e) => e.statusLabel); // Extract all statuses
  }

  

  const formatShowTime = (ticketStartTime) => {
    const showTime = moment(ticketStartTime).tz("Asia/Kolkata");
    const today = moment().tz("Asia/Kolkata");
    const yesterday = moment().tz("Asia/Kolkata").subtract(1, "days");

    if (showTime.isSame(today, "day")) {
      return showTime.format("h:mm A");
    } else if (showTime.isSame(yesterday, "day")) {
      return "Yesterday ";
    } else {
      return showTime.format("DD/MM/YY");
    }
  };

  const handleTicketClick = (ticketId) => {
    ticket.newCommentForAssignee = false;
    handleSelectButtonClick(ticketId);
  };


  return (
    <Fragment>
      {/* Static UI */}
      {/* <div className="ticketList_box">
          <div className="TicketSnap_LeftSide">
            <div className="UnreadDot"><span></span></div>
            <div className="TicketSnap_Avtar">AH</div>
            <div className="TicketSnaps">
              <div className="TicketSnap_Title">AC | Temp too cold</div>
              <div className="TicketSnap_Location">Equentia SCF Technologies Private Ltd. (GVT, Gurgaon)  </div>
              <div className="TicketSnap_OtherInfo">
                <span>Internal</span>
                <span>#23344</span>
                <span>Due on 12th April, 01:00 PM</span>
              </div>
            </div>
          </div>
          <div className="TicketSnap_rightSide">
            <div className="TicketSnap_Time">10:34 AM</div>
            <div className="TicketSnap_Actions">
              <Dropdown>
                <Dropdown.Toggle variant="" className="TicketSnap_ActionsDD" id="dropdown-basic">
                  To-Do
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item href="#/action-1">Under review</Dropdown.Item>
                  <Dropdown.Item href="#/action-2">In progress</Dropdown.Item>
                  <Dropdown.Item href="#/action-3">Done</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div> */}

      {/* New Code */}

      <div
        className={`ticketList_box ActiveTicketTab_no ${
          ticket.escalationStatus === "Critical" ? "Criticalticket_box" : ""
        } ${selectedTicketId === ticket._id ? "selectedTicket" : ""}`}
        onClick={() => handleTicketClick(ticket._id)}
      >
        <div
          className="TicketSnap_LeftSide"
          onClick={() =>
            openNewTabWithRoute(ticket?.ticketNumber, ticket?.status)
          }
        >
          {/* for dot we can use className="UnreadDot" and remove style */}
          {ticket?.newCommentForAssignee ?
          <div className="UnreadDot">
            <span></span>
          </div>
          : ""}

          {/* <div className="TicketSnap_Avtar">
            {groupTypeValue}
          </div> */}
          <div
            style={{
              backgroundColor:
                groupTypeValue === "op"
                  ? "#A96AC2"
                  : groupTypeValue === "tc"
                  ? "#AF9C92"
                  : groupTypeValue === "it"
                  ? "#28467E"
                  : groupTypeValue === "am"
                  ? "#5D7F6C"
                  : groupTypeValue === "md"
                  ? "#A56C4B"
                  : groupTypeValue === "is"
                  ? "#5385D0"
                  : "",
            }}
            className="TicketSnap_Avtar"
          >
            {groupTypeValue}
          </div>
          {}
          <div className="TicketSnaps">
            <div className="TicketSnap_Title">
              <span className="TicketSnap_Title_Elipses">
                {ticket.subCategoryId ? ticket.subCategoryId.category : ""} |{" "}
                {ticket.subCategoryId ? ticket.subCategoryId.subCategory : ""}
              </span>

              {ticket.escalationStatus === "Critical" ? (
                <span className="IsCriticalBadge">
                  <img src={CriticalIcon} />
                </span>
              ) : ticket.escalationStatus == "Over Due" ? (
                <span className="InprogressIcon">
                  <img src={OverdueIcon} alt="" />
                </span>
              ) : ticket.escalationStatus == "E1" ? (
                <span className="CriticalLevelBadge">
                  <img src={E1Icon} alt="" />
                </span>
              ) : ticket.escalationStatus == "E2" ? (
                <span className="CriticalLevelBadge">
                  <img src={E2Icon} alt="" />
                </span>
              ) : ticket.escalationStatus == "E3" ? (
                <span className="CriticalLevelBadge">
                  <img src={E3Icon} alt="" />
                </span>
              ) : ticket.escalationStatus == "Reopen" ? (
                <span className="CriticalLevelBadge">
                  <img src={ReOpenIcon} alt="" />
                </span>
              ) : ticket.escalationStatus == "Returned" ? (
                <span className="CriticalLevelBadge">
                  <img src={ReturnedTicketRedIcon} alt="" />
                </span>
              ) : (
                ""
              )}
              {/* {ticket.isDueDateBreached === true ?
                <span className="InprogressIcon">
                  <img src={InProgressIcon} alt="" />
                </span> : null
              }

              {ticket.escalationLevel > 0 ? (
                <span className="CriticalLevelBadge">
                  E{ticket.escalationLevel}
                </span>
              ) : (
                ""
              )} */}
            </div>
            <div className="TicketSnap_Location d-flex align-items-center">
              <span
                className={`TicketSnap_CName_Elipses ${
                  [
                    "DLF Commercial",
                    "Victoria Park",
                    "Times Square",
                    "Summer Court",
                    "Jaipur Center",
                    "Green County",
                    "Golden Millenium",
                    "Bharti Vilas",
                    "Aurobindo",
                  ].includes(ticket.locationId.locationShortCode)
                    ? "ShortCodeLg"
                    : ""
                }`}
              >
                {ticket.companyName}
              </span>
              <span className="ms-1">({ticket.locationId.locationShortCode})</span>
            </div>
            <div className="TicketSnap_OtherInfo">
              <span>
                {ticket?.ticketType?.charAt(0)?.toUpperCase() +
                  ticket?.ticketType?.slice(1)}
              </span>
              <span>#{ticket.ticketNumber}</span>
              {ticket?.status === "Done" ? (
                ticket.rating ? (
                  <span className="RatingStars">
                    {[...Array(ticket.rating)].map((_, i) => (
                      <img key={i} src={starIcon} alt="" />
                    ))}
                  </span>
                ) : (
                  ""
                )
              ) : (
                <span>{dueText}</span>
              )}
            </div>
          </div>
        </div>
        <div className="TicketSnap_rightSide">
          <div className="TicketSnap_Time">
            {formatShowTime(ticket.startTime)}
          </div>
          <div className="TicketSnap_Actions">
            <Dropdown>
                  {/* <Dropdown.Toggle variant="" className={selectedStatus}>
                    {selectedStatus} */}
                  <Dropdown.Toggle variant="" className={`TicketSnap_ActionsDD ${ticket?.status}`}>
                    {ticket?.statusOption?.find(opt => opt?.status === ticket.status)?.statusLabel || 
                     (ticket?.status === "Reopen" ? "Reopened" : ticket?.status)}
                  </Dropdown.Toggle>
                  {buttonValues?.length > 0 ? (
                    <Dropdown.Menu>
                      {buttonValues.map((statusLabel, index) => (
                        <Dropdown.Item
                          key={index}
                          href="#"
                          onClick={() => handleButtonClick(ticket._id, ticket.statusOption[index].status)}
                        >
                          {statusLabel}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  ) : (
                    ""
                  )}
                </Dropdown>
          </div>
        </div>
      </div>

      {/* Old */}
      {/* <div className="d-flex justify-content-start align-items-center ticket-box text-nowrap">
          <div className="avatar-wrapper">
            <div className="avatar me-2">
              <div className="rounded-circle avatar-initials text-uppercase">
                {groupTypeValue}
              </div>
            </div>
          </div>
          <div className="d-flex flex-column m-2">
            <p className="m-0">
              <span className="text-body">
                {ticket.subCategoryId ? ticket.subCategoryId.category : ""} -{" "}
                {ticket.subCategoryId ? ticket.subCategoryId.subCategory : ""}
              </span>
              &nbsp;
              {ticket.isCritical ? (
                <i className="fa-solid fa-triangle-exclamation critical-icon"></i>
              ) : (
                ""
              )}
              &nbsp;
              {ticket.escalationLevel > 0 ? (
                <span className="badge badge-danger text-uppercase">
                  E{ticket.escalationLevel}
                </span>
              ) : (
                ""
              )}
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span className="text-muted text-end">
                {formatShowTime(ticket.startTime)}
              </span>
            </p>
            <small className="text-muted">
              {ticket.companyName} ({ticket.locationId.locationName})
            </small>
            <small className="text-muted d-flex align-items-center">
              <span className="text-capitalize">{ticket.ticketType}</span>
              <span className="dot mx-2"></span>#{ticket.ticketNumber}
              <span className="dot mx-2"></span>Due on{" "}
              {moment(ticket.dueDate)
                .tz("Asia/Kolkata")
                .format("DD MMMM, hh:mm A")}
              &nbsp; &nbsp;
              {ticket.status !== "Done" ? (
                <Dropdown>
                  <Dropdown.Toggle size="sm">{ticket.status}</Dropdown.Toggle>
                  {buttonValue.length > 0 ? (
                    <Dropdown.Menu>
                      {buttonValue.map((e, index) => (
                        <Dropdown.Item
                          key={index}
                          href="#"
                          onClick={() => handleButtonClick(ticket._id, e)}
                        >
                          {e}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  ) : (
                    ""
                  )}
                </Dropdown>
              ) : (
                ""
              )}
            </small>
          </div>
        </div> */}
    </Fragment>
  );
};

export default Ticket;
